export default function formatMessageContentFile ({
    url,
    name,
    size
}) {
    // eslint-disable-next-line
    let newtype = name.match(/[^\.]+$/)[0]
    return {
        fileName: name,
        fileSize: Number(size),
        url,
        type: newtype
    }
}
